<template>
    <div class="reg-list">
        <lgn-input class="reg-list-search" placeholder="搜尋" v-model="searchText" 
        :suffix="true" :suffix-icon="'el-icon-search'" :suffix-method="searchReg"
        @keyup.enter.native="searchReg">
            <div class="lgn-input__preSelect" slot="preSelect">
                <div class="lgn-input__preSelect-select" v-clickoutside="closeInputSelect">
                    <span class="lgn-input__preSelect-select-text">{{searchStatusLabal()}}</span>
                    <span class="lgn-input__preSelect-select-icon el-icon-arrow-down" @click="openInputSelect()"></span>
                </div>
                <div class="lgn-input__preSelect-option" :class="{'open' : isOpenInputSelect}">
                    <div class="lgn-input__preSelect-option-item" v-for="(item, index) in regPreSelectList" :key="index"
                     @click="chooseInputSelectOption(item.value)">{{item.key}}</div>
                </div>
            </div>
        </lgn-input>
        <div class="reg-list-info">
            <span>連線：</span>
            <i class="reg-status-icon tag-success">正常</i>
            <i class="reg-status-icon tag-warning">故障</i>
            <i class="reg-status-icon tag-none">無</i>
        </div>
        <div class="paca-table">
            <div class="paca-table__header">
                <div class="paca-table__header-item item-column column-site-name">{{$t("table.header.siteName")}} ({{regSearchList.length}})</div>
                <div class="paca-table__header-item item-column column-ip">{{$t("table.header.ip")}}</div>
                <div class="paca-table__header-item item-column column-site">{{$t("table.header.site")}}</div>
                <div class="paca-table__header-item item-column column-vendor">{{$t("table.header.vendor")}}</div>
                <div class="paca-table__header-item item-column column-hw">{{$t("table.header.hw")}}</div>
                <div class="paca-table__header-item item-column column-box">{{$t("table.header.box")}}</div>
                <div class="paca-table__header-item item-column column-sw">{{$t("table.header.sw")}}</div>
                <div class="paca-table__header-item item-column column-hw">{{$t("table.header.createTime")}}</div>
                <div class="paca-table__header-item item-column column-connection">{{$t("table.header.connection")}}</div>
                <div class="paca-table__header-item item-column column-status">{{$t("table.header.status")}}</div>
                <div class="paca-table__header-item item-column column-action">
                    <button type="button" class=""><a :href="csvFile" download="paca_reglist.csv" class="column-action-download el-icon-download" v-if="csvFile"></a></button>
                </div>
            </div>
            <div class="paca-table__body" v-if="viewRegSearchList.length > 0">
                <div class="paca-table__body-col" v-for="(secItem, secIndex) in viewRegSearchList" :key="secIndex">
                    <div class="paca-table__body-col-list">
                        <div class="paca-table__body-col-list-item item-column column-site-name overflow-text">
                            <a :href="secItem.http_href" target="_blank">{{secItem.name}}</a>
                            <a :href="secItem.ssh_href" target="_blank" class="column-site-name-icon ssh-icon"></a>
                        </div>
                        <div class="paca-table__body-col-list-item item-column column-ip"><a :href="secItem.ssh_href" target="_blank">{{secItem.ip}}</a></div>
                        <div class="paca-table__body-col-list-item item-column column-site overflow-text">{{secItem.site}}</div>
                        <div class="paca-table__body-col-list-item item-column column-vendor">{{secItem.vendor}}</div>
                        <div class="paca-table__body-col-list-item item-column column-hw">{{secItem.hw}}</div>
                        <div class="paca-table__body-col-list-item item-column column-box overflow-text">{{secItem.box}}</div>
                        <div class="paca-table__body-col-list-item item-column column-sw">{{secItem.sw}}</div>
                        <div class="paca-table__body-col-list-item item-column column-created">{{secItem.created}}</div>
                        <div class="paca-table__body-col-list-item item-column column-connection">
                            <i class="reg-status-icon" :class="regResultSystemIcon.threeType[secItem.db]">DB</i>
                            <i class="reg-status-icon" :class="regResultSystemIcon.threeType[secItem.net]">NET</i>
                        </div>
                        <div class="paca-table__body-col-list-item item-column column-status">
                            <el-select v-model="secItem.status" @change="updateRegStatus(secItem.id, secItem.status)">
                                <el-option v-for="(thirdItem,thirdIndex) in regListStatus" :key="thirdIndex" :label="thirdItem.key" :value="thirdItem.value"></el-option>
                            </el-select>
                        </div>   
                        <div class="paca-table__body-col-list-item item-column column-action">
                            <button class="column-action-button el-icon-document" @click="openItemInfoDialog(secItem)"></button>
                            <button class="column-action-button el-icon-s-tools" :disabled="secItem.extra_info.id == 0" @click="openEditingItemDialog(secItem)"></button>
                        </div>
                    </div>
                </div>
                <button type="button" class="paca-table__body-more" v-if="isShowMoreButton" @click="regListIteration()">更多</button>
            </div>
            <div class="paca-table__empty" v-else></div>
        </div>
        <el-dialog class="reg-list-viewinfo-dialog" :visible.sync="isViewItemInfoDialog">
            <div slot="title">場站資訊</div>
            <div class="reg-list-viewinfo-dialog__body" v-if="viewItem">
                <div class="reg-list-viewinfo-dialog__body-item">
                    <div class="reg-list-viewinfo-dialog__body-item-label">{{$t("table.header.siteName")}}</div>
                    <div class="reg-list-viewinfo-dialog__body-item-value">
                        <a :href="viewItem.http_href" target="_blank">{{viewItem.name}}</a>
                    </div>
                </div>
                <div class="reg-list-viewinfo-dialog__body-item">
                    <div class="reg-list-viewinfo-dialog__body-item-label">{{$t("table.header.ip")}}</div>
                    <div class="reg-list-viewinfo-dialog__body-item-value">
                        <a :href="viewItem.ssh_href" target="_blank">{{viewItem.ip}}</a>
                    </div>
                </div>
                <div class="reg-list-viewinfo-dialog__body-item">
                    <div class="reg-list-viewinfo-dialog__body-item-label">{{$t("table.header.site")}}</div>
                    <div class="reg-list-viewinfo-dialog__body-item-value">{{viewItem.site}}</div>
                </div>
                <div class="reg-list-viewinfo-dialog__body-item">
                    <div class="reg-list-viewinfo-dialog__body-item-label">{{$t("table.header.vendor")}}</div>
                    <div class="reg-list-viewinfo-dialog__body-item-value">{{viewItem.vendor}}</div>
                </div>
                <div class="reg-list-viewinfo-dialog__body-item">
                    <div class="reg-list-viewinfo-dialog__body-item-label">{{$t("table.header.hw")}}</div>
                    <div class="reg-list-viewinfo-dialog__body-item-value">{{viewItem.hw}}</div>
                </div>
                <div class="reg-list-viewinfo-dialog__body-item">
                    <div class="reg-list-viewinfo-dialog__body-item-label">{{$t("table.header.box")}}</div>
                    <div class="reg-list-viewinfo-dialog__body-item-value">{{viewItem.box}}</div>
                </div>
                <div class="reg-list-viewinfo-dialog__body-item">
                    <div class="reg-list-viewinfo-dialog__body-item-label">{{$t("table.header.sw")}}</div>
                    <div class="reg-list-viewinfo-dialog__body-item-value">{{viewItem.sw}}</div>
                </div>
                <div class="reg-list-viewinfo-dialog__body-item">
                    <div class="reg-list-viewinfo-dialog__body-item-label">{{$t("table.header.createTime")}}</div>
                    <div class="reg-list-viewinfo-dialog__body-item-value">{{viewItem.created}}</div>
                </div>
                <div class="reg-list-viewinfo-dialog__body-item">
                    <div class="reg-list-viewinfo-dialog__body-item-label">{{$t("table.header.connection")}}</div>
                    <div class="reg-list-viewinfo-dialog__body-item-value">
                        <i class="reg-status-icon" :class="regResultSystemIcon.threeType[viewItem.db]">DB</i>
                            <i class="reg-status-icon" :class="regResultSystemIcon.threeType[viewItem.net]">NET</i>
                    </div>
                </div>
                <div class="reg-list-viewinfo-dialog__body-item">
                    <div class="reg-list-viewinfo-dialog__body-item-label">{{$t("table.header.status")}}</div>
                    <div class="reg-list-viewinfo-dialog__body-item-value">
                        <el-select v-model="viewItem.status" @change="updateRegStatus(viewItem.id, viewItem.status)">
                            <el-option v-for="(thirdItem,thirdIndex) in regListStatus" :key="thirdIndex" :label="thirdItem.key" :value="thirdItem.value"></el-option>
                        </el-select>
                    </div>
                </div>
            </div>
            <div slot="footer">
                <button type="button" class="reg-search-info-dialog__footer-button main-button" @click="CloseItemInfoDialog">確認</button>
            </div>
        </el-dialog>
        <el-dialog class="reg-list-setting-dialog" :visible.sync="isEditingDialogOpen">
            <div slot="title">場站編輯</div>
            <div class="reg-list-setting-dialog__body" v-if="editingItem">
                <div class="reg-list-setting-dialog__body-item">
                    <div class="reg-list-setting-dialog__body-item-label">名稱</div>
                    <div class="reg-list-setting-dialog__body-item-value editingItem-name">{{editingItem.name}}</div>
                </div>
                <div class="reg-list-setting-dialog__body-item" v-if="userInfo.user_services.find(item => item.name == 'NTPServicesReports') || userInfo.is_admin != 0">
                    <div class="reg-list-setting-dialog__body-item-label">新北回報</div>
                    <el-switch v-model="editingItem.extra_info.services_reports" :active-value="1" :inactive-value="0" active-color="#9B90C2" inactive-color="#dedfe0" class="reg-list-setting-dialog__body-item-value editingItem-mark"></el-switch>
                </div>
                <div class="reg-list-setting-dialog__body-item">
                    <div class="reg-list-setting-dialog__body-item-label">DB Con.</div>
                    <el-switch v-model="editingItem.extra_info.collection_mark" :active-value="1" :inactive-value="0" active-color="#9B90C2" inactive-color="#dedfe0" class="reg-list-setting-dialog__body-item-value editingItem-mark"></el-switch>
                </div>
                <div class="reg-list-setting-dialog__body-item">
                    <div class="reg-list-setting-dialog__body-item-label">Pub IP</div>
                    <lgn-input class="reg-list-setting-dialog__body-item-value editingItem-ip" v-model="editingItem.extra_info.pub_ip"></lgn-input>
                </div>
                <div class="reg-list-setting-dialog__body-item">
                    <div class="reg-list-setting-dialog__body-item-label">city</div>
                    <lgn-input class="reg-list-setting-dialog__body-item-value editingItem-ip" v-model="editingItem.extra_info.city"></lgn-input>
                </div>
                <div class="reg-list-setting-dialog__body-item">
                    <div class="reg-list-setting-dialog__body-item-label">WEB</div>
                    <lgn-input class="reg-list-setting-dialog__body-item-value editingItem-web" v-model="editingItem.extra_info.pub_http"></lgn-input>
                </div>
                <div class="reg-list-setting-dialog__body-item">
                    <div class="reg-list-setting-dialog__body-item-label">SSH</div>
                    <lgn-input class="reg-list-setting-dialog__body-item-value editingItem-ssh" v-model="editingItem.extra_info.pub_ssh"></lgn-input>
                </div>
                <div class="reg-list-setting-dialog__body-item">
                    <div class="reg-list-setting-dialog__body-item-label">FTP</div>
                    <lgn-input class="reg-list-setting-dialog__body-item-value editingItem-ftp" v-model="editingItem.extra_info.fetc_ftp_host"></lgn-input>
                </div>
                <div class="reg-list-setting-dialog__body-item">
                    <div class="reg-list-setting-dialog__body-item-label">User</div>
                    <lgn-input class="reg-list-setting-dialog__body-item-value editingItem-user" v-model="editingItem.extra_info.fetc_ftp_user"></lgn-input>
                </div>
                <div class="reg-list-setting-dialog__body-item">
                    <div class="reg-list-setting-dialog__body-item-label">Pwd</div>
                    <lgn-input class="reg-list-setting-dialog__body-item-value editingItem-pwd" v-model="editingItem.extra_info.fetc_ftp_pwd"></lgn-input>
                </div>
                <div class="reg-list-setting-dialog__body-item">
                    <div class="reg-list-setting-dialog__body-item-label">Cert</div>
                    <lgn-input class="reg-list-setting-dialog__body-item-value editingItem-cert" v-model="editingItem.extra_info.fetc_cert_pwd"></lgn-input>
                </div>
            </div>
            <div slot="footer" v-if="editingItem">
                <button type="button" class="reg-search-info-dialog__footer-button second-button" @click="closeEditingDialog">取消</button>
                <button type="button" class="reg-search-info-dialog__footer-button main-button" :disabled="editingItem.extra_info.id == 0" @click="updateExtraInfo">送出</button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import itemTrim from '@/script/trim/trim.js'
import * as api from '@/script/apiService/api.js'
import * as regListMapping from '@/script/regListMapping/regListMapping.js'
import lgnInput from '@/lgnComponents/lgnInput/lgnInput.vue'
import {getFullTime} from '@/script/time/time.js'

let regPreSelectList = [
    {key: "全部", value: 0},
    {key: "網路中斷", value: 1},
    {key: "資料庫中斷", value: 2},
    {key: "運行場站", value: 3}
];
let searchStatus = 0;

export default {
    name: "regList",
    data(){
        return{
            searchText: '',
            regSearchList: [],
            regCollapse: "",
            regListStatus: regListMapping.getRegSystemStatusMappingList(),
            regResultSystemIcon: regListMapping.getRegSystemIconMappingList(),
            regResultDeviceIcon: regListMapping.getRegDeviceIconMappingList(),
            loadingMethod: null,
            tableLoading: false,
            editingItem: null,
            sourceEditingCollectionMark: null,
            sourceEditingServiceReport: null,
            isEditingDialogOpen: false,
            isOpenInputSelect: false,
            viewItem: null,
            isViewItemInfoDialog: false,
            searchStatus: 0,
            regPreSelectList: [
                {key: "全部", value: 0},
                {key: "網路中斷", value: 1},
                {key: "資料庫中斷", value: 2},
                {key: "運行場站", value: 3}
            ],
            csvFile: null,
            isShowMoreButton: true,
            viewMoreCount: 0,
            viewRegSearchList: [],
        }
    },
    components: {
        lgnInput
    },
    methods: {
        searchStatusLabal(){
            let status = this.regPreSelectList.find(item => item.value == this.searchStatus);
            return status.key
        },
        closeInputSelect(){
            if(document.querySelector(".reg-list .lgn-input__preSelect-option")){
                document.querySelector(".reg-list .lgn-input__preSelect-option").classList.remove("open");
            }
            // this.isOpenInputSelect = false;
        },
        openInputSelect(){
            let classList = document.querySelector(".reg-list .lgn-input__preSelect-option").classList;
            if(classList.contains("open")){
                document.querySelector(".reg-list .lgn-input__preSelect-option").classList.remove("open");
            }else {
                classList.add("open");
            }
        },
        chooseInputSelectOption(value){
            document.querySelector(".reg-list .lgn-input__preSelect-option").classList.remove("open");
            searchStatus = value;
            let text = regPreSelectList.find(item => item.value == searchStatus);
            document.querySelector(".reg-list .lgn-input__preSelect-select-text").innerText = text.key;
        },
        async searchReg(){
            this.viewMoreCount = 0;
            this.isShowMoreButton = true;
            this.viewRegSearchList = [];
            this.$nextTick(() => {
                this.tableLoading = true;
            })
            let res = null;
            if(searchStatus == 0){
                res = await api.postAdminRegSearch(itemTrim(this.searchText));
            }
            else if(searchStatus == 1){
                res = await api.postAdminRegSearch(itemTrim(this.searchText), "updated");
            }
            else if(searchStatus == 2){
                res = await api.postAdminRegSearch(itemTrim(this.searchText), "db");
            }
            else if(searchStatus == 3){
                res = await api.postAdminRegSearch(itemTrim(this.searchText), "live");
            }
            if(!res.error_status){
                setTimeout(function(){
                    let csvText = `場站名稱, IP, SSH_PORT\r\n`;
                    res.forEach(item => {
                        item.extra_info.fetc_cert_pwd = item.extra_info.fetc_cert_pwd || `P@${item.vendor.slice(1,item.vendor.length)}`;
                        item.extra_info.fetc_ftp_user = item.extra_info.fetc_ftp_user || "P00";
                        item.extra_info.pub_ssh = item.extra_info.pub_ssh || 15001;
                        item.extra_info.pub_http = item.extra_info.pub_http || 15000;
                        item.extra_info.fetc_ftp_pwd = item.extra_info.fetc_ftp_pwd || "";
                        item.extra_info.site_code = item.extra_info.site_code || item.site;
                        item.extra_info.collection_mark = item.extra_info.collection_mark > 0 ? 1 : 0;
                        item.http_href = `http://${item.ip}:${item.extra_info.pub_http}`;
                        item.ssh_href = `ssh://op@${item.extra_info.pub_ip ? item.extra_info.pub_ip : item.ip}:${item.extra_info.pub_ssh}`;
                        csvText += `${item.name}, ${item.ip}, ${item.extra_info.pub_http}\r\n`;
                        if(item.extra_info.collection_mark == 0){
                            item.db = 0;
                        }
                    })
                    res.sort(function(a, b){
                        if(a.site.length > 7){
                            return 1;
                        }else if(a.site > b.site){
                            return 1;
                        } else if (a.site < b.site){
                            return -1;
                        } else {
                            return 0;
                        }
                    })
                    this.csvFile = `data:text/csv;charset=UTF-8,${encodeURIComponent(csvText)}`;
                    this.tableLoading = false;
                    setTimeout(function(){
                        this.regSearchList = res;
                        this.regListIteration();
                    }.bind(this), 300);
                }.bind(this), 300);
            }
        },
        regListIteration(){
            if((this.viewMoreCount + 1)*30 >= this.regSearchList.length){
                this.isShowMoreButton = false;
            }
            this.viewRegSearchList = this.viewRegSearchList.concat(this.regSearchList.slice(this.viewMoreCount*30, (this.viewMoreCount + 1) * 30));
            this.viewMoreCount += 1;
        },
        async updateRegStatus(id, value){
            let data = {
                id: id,
                status: value
            }
            let res = await api.putRegSetting(data);
            if(!res.error_status){

            }else if(res.error_status != '401' && res.error_status != '504'){
                this.$message.error({
                    showClose: true,
                    duration: 2500,
                    message: "發生錯誤!"
                })
            }
        },
        openItemInfoDialog(item){
            this.viewItem = JSON.parse(JSON.stringify(item));
            this.isViewItemInfoDialog = true;
        },
        CloseItemInfoDialog(){
            this.isViewItemInfoDialog = false;
        },
        openEditingItemDialog(item){
            this.editingItem = item;
            this.sourceEditingCollectionMark = item.extra_info.collection_mark;
            this.sourceEditingServiceReport = item.extra_info.services_reports;
            this.isEditingDialogOpen = true;
            this.$nextTick(() => {
                document.querySelectorAll(`.reg-list-setting-dialog__body .is-required`).forEach(e => e.classList.remove("is-required"));
            });
        },
        async updateExtraInfo(){
            let sendData = {
                id: this.editingItem.extra_info.id,
                site_code: this.editingItem.extra_info.site_code,
                pub_ip: this.editingItem.extra_info.pub_ip,
                pub_http: this.editingItem.extra_info.pub_http,
                pub_ssh: this.editingItem.extra_info.pub_ssh,
                fetc_ftp_host: this.editingItem.extra_info.fetc_ftp_host,
                fetc_ftp_user: this.editingItem.extra_info.fetc_ftp_user,
                fetc_ftp_pwd: this.editingItem.extra_info.fetc_ftp_pwd,
                fetc_cert_pwd: this.editingItem.extra_info.fetc_cert_pwd,
                replication: this.editingItem.extra_info.replication
            };
            document.querySelectorAll(`.reg-list-setting-dialog__body .is-required`).forEach(e => e.classList.remove("is-required"));
            let notEmpty = true;
            if(itemTrim(sendData.pub_http) == ''){
                document.querySelector(".editingItem-web").classList.add("is-required");
                notEmpty = false;
            }
            if(itemTrim(sendData.pub_ssh) == ''){
                document.querySelector(".editingItem-ssh").classList.add("is-required");
                notEmpty = false;
            }
            if(itemTrim(sendData.fetc_ftp_user) == ''){
                document.querySelector(".editingItem-user").classList.add("is-required");
                notEmpty = false;
            }
            if(itemTrim(sendData.fetc_cert_pwd) == ''){
                document.querySelector(".editingItem-cert").classList.add("is-required");
                notEmpty = false;
            }
            if(notEmpty){
                let res = await api.putAdminRegExtraInfo(itemTrim(sendData));
                if(this.sourceEditingCollectionMark != this.editingItem.extra_info.collection_mark){
                    let collectionMarkData = {
                        id: sendData.id,
                        collection_mark : this.editingItem.extra_info.collection_mark
                    }
                    let collectionRes = await api.putAdminRegExtraInfoCollectionMark(collectionMarkData);
                    if(collectionRes.error_status == '401' || collectionRes.error_status == '504'){
                        this.$message.error({
                            duration: 2500,
                            showClose: true,
                            message: "發生錯誤!"
                        })
                    }
                }
                if(this.sourceEditingServiceReport != this.editingItem.extra_info.services_reports){
                    let serviceReportData = {
                        id: sendData.id,
                        services_reports : this.editingItem.extra_info.services_reports
                    }
                    let serviceReportRes = await api.putAdminRegExtraInfoServiceReport(serviceReportData);
                    if(serviceReportRes.error_status == '401' || serviceReportRes.error_status == '504'){
                        this.$message.error({
                            duration: 2500,
                            showClose: true,
                            message: "發生錯誤!"
                        })
                    }
                }
                if(!res.error_status){
                    document.querySelectorAll(`.reg-list-setting-dialog__body .is-required`).forEach(e => e.classList.remove("is-required"));
                    this.isEditingDialogOpen = false;
                }else if(res.error_status != '401' && res.error_status != '504'){
                    this.$message.error({
                        duration: 2500,
                        showClose: true,
                        message: "發生錯誤!"
                    })
                }
            } else{
                this.$message.error({
                    duration: 2500,
                    showClose: true,
                    message: "請確認必填欄位!"
                })
            }
        },
        closeEditingDialog(){
            this.isEditingDialogOpen = false;
        },
        addViewMoreCount(){
            this.viewMoreCount += 1;
        }
    },
    computed: {
        userInfo(){
            return this.$store.state.userInfo
        }
    },
    watch: {
        tableLoading(value){
            let hasData = document.querySelector(".paca-table__body");
            let loadingStyle = "";
            let asideWidth = document.querySelector(".el-aside").offsetWidth;
            if(hasData){
                loadingStyle = hasData.offsetHeight > document.querySelector(".el-main").offsetHeight/2 ? 'screen-align' : 'empty-align';
            }
            if(asideWidth > 150){
                loadingStyle += " collapse-open";
            }else if(asideWidth > 50){
                loadingStyle += " collapse-exist";
            }
            if(value == true){
                this.loadingMethod = this.$loading({
                    lock: true,
                    target: '.paca-table__empty',
                    text: '搜尋中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(255,255,255,0.8)',
                    customClass: loadingStyle
                });
            }else{
                if(this.loadingMethod != null){
                    this.loadingMethod.close();
                }
            }
        },
    },
    activated(){
        if(this.$route.params.site || this.$route.params.status){
            this.searchText = this.$route.params.site;
            searchStatus = this.$route.params.status || 0;
            this.searchStatus = searchStatus;
            setTimeout(function(){
                this.searchReg();
            }.bind(this), 200);
        }
    }
}
</script>